import { render } from "./Kushki.vue?vue&type=template&id=75982632"
import script from "./Kushki.vue?vue&type=script&lang=js"
export * from "./Kushki.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__